import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelCaseSplitPipe',
  standalone: false
})
export class CamelCaseSplitPipePipe implements PipeTransform {
  /**
   * Transforms a camelCase string into a space-separated string.
   *
   * Splits the input string at each uppercase letter and joins the resulting substrings with spaces.
   * If the input is undefined or empty, returns undefined.
   *
   * @param camelCase - The camelCase string to transform.
   * @returns The transformed string with spaces, or undefined if input is not provided.
   */
  transform(camelCase?: string): string | undefined {
    if (camelCase) {
      return camelCase.split(/(?=[A-Z])/).join(' ');
    }
    return;
  }
}
